import _objectWithoutProperties from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _wrapNativeSuper from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _asyncToGenerator from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _excluded = ["src"];

var _globalThis$document, _globalThis$HTMLEleme;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "C:\\Users\\eric.sangabriel\\Documents\\GitHub\\web\\node_modules\\@babel\\runtime\\regenerator\\index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import "core-js/modules/esnext.global-this.js";
// https://developers.google.com/youtube/iframe_api_reference
var EMBED_BASE = 'https://www.youtube.com/embed';
var API_URL = 'https://www.youtube.com/iframe_api';
var API_GLOBAL = 'YT';
var API_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_SRC = /(?:youtu\.be\/|youtube\.com\/(?:shorts\/|embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/;
var templateShadowDOM = (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.createElement('template');

if (templateShadowDOM) {
  templateShadowDOM.innerHTML =
  /*html*/
  "\n  <style>\n    :host {\n      display: inline-block;\n      line-height: 0;\n      position: relative;\n      min-width: 300px;\n      min-height: 150px;\n    }\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  </style>\n  ";
}

var _options = /*#__PURE__*/new WeakMap();

var _readyState = /*#__PURE__*/new WeakMap();

var _seeking = /*#__PURE__*/new WeakMap();

var _seekComplete = /*#__PURE__*/new WeakMap();

var YoutubeVideoElement = /*#__PURE__*/function (_ref) {
  _inherits(YoutubeVideoElement, _ref);

  var _super = _createSuper(YoutubeVideoElement);

  function YoutubeVideoElement() {
    var _this;

    _classCallCheck(this, YoutubeVideoElement);

    _this = _super.call(this);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _options, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _readyState, {
      writable: true,
      value: 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _seeking, {
      writable: true,
      value: false
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _seekComplete, {
      writable: true,
      value: void 0
    });

    _defineProperty(_assertThisInitialized(_this), "isLoaded", false);

    _this.attachShadow({
      mode: 'open'
    });

    _this.shadowRoot.append(templateShadowDOM.content.cloneNode(true));

    _this.loadComplete = new PublicPromise();
    return _this;
  }

  _createClass(YoutubeVideoElement, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$preload,
            _this2 = this;

        var oldApi, matches, metaId, src, iframe, YT, playFired, lastCurrentTime, lastBufferedEnd, progressInterval;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.hasLoaded) {
                  this.loadComplete = new PublicPromise();
                  this.isLoaded = false;
                }

                this.hasLoaded = true;

                _classPrivateFieldSet(this, _readyState, 0);

                this.dispatchEvent(new Event('emptied'));
                oldApi = this.api;
                this.api = null; // Wait 1 tick to allow other attributes to be set.

                _context.next = 8;
                return Promise.resolve();

              case 8:
                oldApi === null || oldApi === void 0 ? void 0 : oldApi.destroy();

                if (this.src) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                this.dispatchEvent(new Event('loadstart'));

                _classPrivateFieldSet(this, _options, {
                  autoplay: this.autoplay,
                  controls: this.controls,
                  loop: this.loop,
                  mute: this.defaultMuted,
                  playsinline: this.playsInline,
                  preload: (_this$preload = this.preload) !== null && _this$preload !== void 0 ? _this$preload : 'metadata',
                  origin: location.origin,
                  enablejsapi: 1,
                  showinfo: 0,
                  rel: 0,
                  iv_load_policy: 3,
                  modestbranding: 1
                });

                matches = this.src.match(MATCH_SRC);
                metaId = matches && matches[1];
                src = "".concat(EMBED_BASE, "/").concat(metaId, "?").concat(serialize(boolToBinary(_classPrivateFieldGet(this, _options))));
                iframe = this.shadowRoot.querySelector('iframe');

                if (!iframe) {
                  iframe = createEmbedIframe({
                    src: src
                  });
                  this.shadowRoot.append(iframe);
                }

                _context.next = 20;
                return loadScript(API_URL, API_GLOBAL, API_GLOBAL_READY);

              case 20:
                YT = _context.sent;
                this.api = new YT.Player(iframe, {
                  events: {
                    onReady: function onReady() {
                      _classPrivateFieldSet(_this2, _readyState, 1); // HTMLMediaElement.HAVE_METADATA


                      _this2.dispatchEvent(new Event('loadedmetadata'));

                      _this2.dispatchEvent(new Event('durationchange'));

                      _this2.dispatchEvent(new Event('volumechange'));

                      _this2.dispatchEvent(new Event('loadcomplete'));

                      _this2.isLoaded = true;

                      _this2.loadComplete.resolve();
                    },
                    onError: function onError(error) {
                      return console.error(error);
                    }
                  }
                });
                /* onStateChange
                  -1 (unstarted)
                  0 (ended)
                  1 (playing)
                  2 (paused)
                  3 (buffering)
                  5 (video cued).
                */

                playFired = false;
                this.api.addEventListener('onStateChange', function (event) {
                  var state = event.data;

                  if (state === YT.PlayerState.PLAYING || state === YT.PlayerState.BUFFERING) {
                    if (!playFired) {
                      playFired = true;

                      _this2.dispatchEvent(new Event('play'));
                    }
                  }

                  if (state === YT.PlayerState.PLAYING) {
                    if (_this2.seeking) {
                      var _classPrivateFieldGet2;

                      _classPrivateFieldSet(_this2, _seeking, false);

                      (_classPrivateFieldGet2 = _classPrivateFieldGet(_this2, _seekComplete)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.resolve();

                      _this2.dispatchEvent(new Event('seeked'));
                    }

                    _classPrivateFieldSet(_this2, _readyState, 3); // HTMLMediaElement.HAVE_FUTURE_DATA


                    _this2.dispatchEvent(new Event('playing'));
                  } else if (state === YT.PlayerState.PAUSED) {
                    var diff = Math.abs(_this2.currentTime - lastCurrentTime);

                    if (!_this2.seeking && diff > 0.1) {
                      _classPrivateFieldSet(_this2, _seeking, true);

                      _this2.dispatchEvent(new Event('seeking'));
                    }

                    playFired = false;

                    _this2.dispatchEvent(new Event('pause'));
                  }

                  if (state === YT.PlayerState.ENDED) {
                    playFired = false;

                    _this2.dispatchEvent(new Event('pause'));

                    _this2.dispatchEvent(new Event('ended'));

                    if (_this2.loop) {
                      _this2.play();
                    }
                  }
                });
                this.api.addEventListener('onPlaybackRateChange', function () {
                  _this2.dispatchEvent(new Event('ratechange'));
                });
                this.api.addEventListener('onVolumeChange', function () {
                  _this2.dispatchEvent(new Event('volumechange'));
                });
                this.api.addEventListener('onVideoProgress', function () {
                  _this2.dispatchEvent(new Event('timeupdate'));
                });
                _context.next = 29;
                return this.loadComplete;

              case 29:
                lastCurrentTime = 0;
                setInterval(function () {
                  var diff = Math.abs(_this2.currentTime - lastCurrentTime);

                  var bufferedEnd = _this2.buffered.end(_this2.buffered.length - 1);

                  if (_this2.seeking && bufferedEnd > 0.1) {
                    var _classPrivateFieldGet3;

                    _classPrivateFieldSet(_this2, _seeking, false);

                    (_classPrivateFieldGet3 = _classPrivateFieldGet(_this2, _seekComplete)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.resolve();

                    _this2.dispatchEvent(new Event('seeked'));
                  } else if (!_this2.seeking && diff > 0.1) {
                    _classPrivateFieldSet(_this2, _seeking, true);

                    _this2.dispatchEvent(new Event('seeking'));
                  }

                  lastCurrentTime = _this2.currentTime;
                }, 50);
                progressInterval = setInterval(function () {
                  var bufferedEnd = _this2.buffered.end(_this2.buffered.length - 1);

                  if (bufferedEnd >= _this2.duration) {
                    clearInterval(progressInterval);

                    _classPrivateFieldSet(_this2, _readyState, 4); // HTMLMediaElement.HAVE_ENOUGH_DATA

                  }

                  if (lastBufferedEnd != bufferedEnd) {
                    lastBufferedEnd = bufferedEnd;

                    _this2.dispatchEvent(new Event('progress'));
                  }
                }, 100);

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "attributeChangedCallback",
    value: function () {
      var _attributeChangedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(attrName) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = attrName;
                _context2.next = _context2.t0 === 'src' ? 3 : 5;
                break;

              case 3:
                this.load();
                return _context2.abrupt("return");

              case 5:
                _context2.next = 7;
                return this.loadComplete;

              case 7:
                _context2.t1 = attrName;
                _context2.next = _context2.t1 === 'autoplay' ? 10 : _context2.t1 === 'controls' ? 10 : _context2.t1 === 'loop' ? 10 : _context2.t1 === 'playsinline' ? 10 : 12;
                break;

              case 10:
                if (_classPrivateFieldGet(this, _options)[attrName] !== this.hasAttribute(attrName)) {
                  this.load();
                }

                return _context2.abrupt("break", 12);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function attributeChangedCallback(_x) {
        return _attributeChangedCallback.apply(this, arguments);
      }

      return attributeChangedCallback;
    }()
  }, {
    key: "play",
    value: function () {
      var _play = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$api;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _classPrivateFieldSet(this, _seekComplete, null);

                _context3.next = 3;
                return this.loadComplete;

              case 3:
                // yt.playVideo doesn't return a play promise.
                (_this$api = this.api) === null || _this$api === void 0 ? void 0 : _this$api.playVideo();
                return _context3.abrupt("return", createPlayPromise(this));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function play() {
        return _play.apply(this, arguments);
      }

      return play;
    }()
  }, {
    key: "pause",
    value: function () {
      var _pause = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$api2;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.loadComplete;

              case 2:
                return _context4.abrupt("return", (_this$api2 = this.api) === null || _this$api2 === void 0 ? void 0 : _this$api2.pauseVideo());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function pause() {
        return _pause.apply(this, arguments);
      }

      return pause;
    }()
  }, {
    key: "seeking",
    get: function get() {
      return _classPrivateFieldGet(this, _seeking);
    }
  }, {
    key: "readyState",
    get: function get() {
      return _classPrivateFieldGet(this, _readyState);
    } // If the getter from SuperVideoElement is overridden, it's required to define
    // the setter again too unless it's a read only property! It's a JS thing.

  }, {
    key: "src",
    get: function get() {
      return this.getAttribute('src');
    },
    set: function set(val) {
      if (this.src == val) return;
      this.setAttribute('src', val);
    }
    /* onStateChange
      -1 (unstarted)
      0 (ended)
      1 (playing)
      2 (paused)
      3 (buffering)
      5 (video cued).
    */

  }, {
    key: "paused",
    get: function get() {
      var _this$api3, _this$api3$getPlayerS;

      if (!this.isLoaded) return !this.autoplay;
      return [-1, 0, 2, 5].includes((_this$api3 = this.api) === null || _this$api3 === void 0 ? void 0 : (_this$api3$getPlayerS = _this$api3.getPlayerState) === null || _this$api3$getPlayerS === void 0 ? void 0 : _this$api3$getPlayerS.call(_this$api3));
    }
  }, {
    key: "duration",
    get: function get() {
      var _this$api$getDuration, _this$api4, _this$api4$getDuratio;

      return (_this$api$getDuration = (_this$api4 = this.api) === null || _this$api4 === void 0 ? void 0 : (_this$api4$getDuratio = _this$api4.getDuration) === null || _this$api4$getDuratio === void 0 ? void 0 : _this$api4$getDuratio.call(_this$api4)) !== null && _this$api$getDuration !== void 0 ? _this$api$getDuration : NaN;
    }
  }, {
    key: "autoplay",
    get: function get() {
      return this.hasAttribute('autoplay');
    },
    set: function set(val) {
      if (this.autoplay == val) return;
      if (val) this.setAttribute('autoplay', '');else this.removeAttribute('autoplay');
    }
  }, {
    key: "buffered",
    get: function get() {
      var _this$api5, _this$api6;

      if (!this.isLoaded) return createTimeRanges();
      var progress = ((_this$api5 = this.api) === null || _this$api5 === void 0 ? void 0 : _this$api5.getVideoLoadedFraction()) * ((_this$api6 = this.api) === null || _this$api6 === void 0 ? void 0 : _this$api6.getDuration());

      if (progress > 0) {
        return createTimeRanges(0, progress);
      }

      return createTimeRanges();
    }
  }, {
    key: "controls",
    get: function get() {
      return this.hasAttribute('controls');
    },
    set: function set(val) {
      if (this.controls == val) return;
      if (val) this.setAttribute('controls', '');else this.removeAttribute('controls');
    }
  }, {
    key: "currentTime",
    get: function get() {
      var _this$api$getCurrentT, _this$api7, _this$api7$getCurrent;

      return (_this$api$getCurrentT = (_this$api7 = this.api) === null || _this$api7 === void 0 ? void 0 : (_this$api7$getCurrent = _this$api7.getCurrentTime) === null || _this$api7$getCurrent === void 0 ? void 0 : _this$api7$getCurrent.call(_this$api7)) !== null && _this$api$getCurrentT !== void 0 ? _this$api$getCurrentT : 0;
    },
    set: function set(val) {
      var _this3 = this;

      if (this.currentTime == val) return;

      _classPrivateFieldSet(this, _seekComplete, new PublicPromise());

      this.loadComplete.then(function () {
        var _this3$api;

        (_this3$api = _this3.api) === null || _this3$api === void 0 ? void 0 : _this3$api.seekTo(val, true);

        if (_this3.paused) {
          var _classPrivateFieldGet4;

          (_classPrivateFieldGet4 = _classPrivateFieldGet(_this3, _seekComplete)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.then(function () {
            var _this3$api2;

            if (!_classPrivateFieldGet(_this3, _seekComplete)) return;
            (_this3$api2 = _this3.api) === null || _this3$api2 === void 0 ? void 0 : _this3$api2.pauseVideo();
          });
        }
      });
    }
  }, {
    key: "defaultMuted",
    get: function get() {
      return this.hasAttribute('muted');
    },
    set: function set(val) {
      if (this.defaultMuted == val) return;
      if (val) this.setAttribute('muted', '');else this.removeAttribute('muted');
    }
  }, {
    key: "loop",
    get: function get() {
      return this.hasAttribute('loop');
    },
    set: function set(val) {
      if (this.loop == val) return;
      if (val) this.setAttribute('loop', '');else this.removeAttribute('loop');
    }
  }, {
    key: "muted",
    get: function get() {
      var _this$api8, _this$api8$isMuted;

      if (!this.isLoaded) return this.defaultMuted;
      return (_this$api8 = this.api) === null || _this$api8 === void 0 ? void 0 : (_this$api8$isMuted = _this$api8.isMuted) === null || _this$api8$isMuted === void 0 ? void 0 : _this$api8$isMuted.call(_this$api8);
    },
    set: function set(val) {
      var _this4 = this;

      if (this.muted == val) return;
      this.loadComplete.then(function () {
        var _this4$api, _this4$api2;

        val ? (_this4$api = _this4.api) === null || _this4$api === void 0 ? void 0 : _this4$api.mute() : (_this4$api2 = _this4.api) === null || _this4$api2 === void 0 ? void 0 : _this4$api2.unMute();
      });
    }
  }, {
    key: "playbackRate",
    get: function get() {
      var _this$api$getPlayback, _this$api9, _this$api9$getPlaybac;

      return (_this$api$getPlayback = (_this$api9 = this.api) === null || _this$api9 === void 0 ? void 0 : (_this$api9$getPlaybac = _this$api9.getPlaybackRate) === null || _this$api9$getPlaybac === void 0 ? void 0 : _this$api9$getPlaybac.call(_this$api9)) !== null && _this$api$getPlayback !== void 0 ? _this$api$getPlayback : 1;
    },
    set: function set(val) {
      var _this5 = this;

      if (this.playbackRate == val) return;
      this.loadComplete.then(function () {
        var _this5$api;

        (_this5$api = _this5.api) === null || _this5$api === void 0 ? void 0 : _this5$api.setPlaybackRate(val);
      });
    }
  }, {
    key: "playsInline",
    get: function get() {
      return this.hasAttribute('playsinline');
    },
    set: function set(val) {
      if (this.playsInline == val) return;
      if (val) this.setAttribute('playsinline', '');else this.removeAttribute('playsinline');
    }
  }, {
    key: "poster",
    get: function get() {
      return this.getAttribute('poster');
    },
    set: function set(val) {
      if (this.poster == val) return;
      this.setAttribute('poster', "".concat(val));
    }
  }, {
    key: "volume",
    get: function get() {
      var _this$api10;

      if (!this.isLoaded) return 1;
      return ((_this$api10 = this.api) === null || _this$api10 === void 0 ? void 0 : _this$api10.getVolume()) / 100;
    },
    set: function set(val) {
      var _this6 = this;

      if (this.volume == val) return;
      this.loadComplete.then(function () {
        var _this6$api;

        (_this6$api = _this6.api) === null || _this6$api === void 0 ? void 0 : _this6$api.setVolume(val * 100);
      });
    }
  }]);

  return YoutubeVideoElement;
}((_globalThis$HTMLEleme = globalThis.HTMLElement) !== null && _globalThis$HTMLEleme !== void 0 ? _globalThis$HTMLEleme : /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  return _createClass(_class);
}());

_defineProperty(YoutubeVideoElement, "observedAttributes", ['autoplay', 'controls', 'crossorigin', 'loop', 'muted', 'playsinline', 'poster', 'preload', 'src']);

var loadScriptCache = {};

function loadScript(_x2, _x3, _x4) {
  return _loadScript.apply(this, arguments);
}

function _loadScript() {
  _loadScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(src, globalName, readyFnName) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!loadScriptCache[src]) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", loadScriptCache[src]);

          case 2:
            if (!(globalName && self[globalName])) {
              _context5.next = 6;
              break;
            }

            _context5.next = 5;
            return delay(0);

          case 5:
            return _context5.abrupt("return", self[globalName]);

          case 6:
            return _context5.abrupt("return", loadScriptCache[src] = new Promise(function (resolve, reject) {
              var script = document.createElement('script');
              script.src = src;

              var ready = function ready() {
                return resolve(self[globalName]);
              };

              if (readyFnName) self[readyFnName] = ready;

              script.onload = function () {
                return !readyFnName && ready();
              };

              script.onerror = reject;
              document.head.append(script);
            }));

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _loadScript.apply(this, arguments);
}

var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

function promisify(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise(function (resolve) {
      fn.apply(void 0, args.concat([function () {
        for (var _len2 = arguments.length, res = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          res[_key2] = arguments[_key2];
        }

        if (res.length > 1) resolve(res);else resolve(res[0]);
      }]));
    });
  };
}

function createPlayPromise(player) {
  return promisify(function (event, cb) {
    var _fn;

    player.addEventListener(event, _fn = function fn() {
      player.removeEventListener(event, _fn);
      cb();
    });
  })('playing');
}
/**
 * A utility to create Promises with convenient public resolve and reject methods.
 * @return {Promise}
 */


var PublicPromise = /*#__PURE__*/function (_Promise) {
  _inherits(PublicPromise, _Promise);

  var _super2 = _createSuper(PublicPromise);

  function PublicPromise() {
    var _this7;

    var executor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    _classCallCheck(this, PublicPromise);

    var res, rej;
    _this7 = _super2.call(this, function (resolve, reject) {
      executor(resolve, reject);
      res = resolve;
      rej = reject;
    });
    _this7.resolve = res;
    _this7.reject = rej;
    return _this7;
  }

  return _createClass(PublicPromise);
}( /*#__PURE__*/_wrapNativeSuper(Promise));

function createElement(tag) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var el = document.createElement(tag);
  Object.keys(attrs).forEach(function (name) {
    return attrs[name] != null && el.setAttribute(name, attrs[name]);
  });

  for (var _len3 = arguments.length, children = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    children[_key3 - 2] = arguments[_key3];
  }

  el.append.apply(el, children);
  return el;
}

var allow = 'accelerometer; autoplay; fullscreen; encrypted-media; gyroscope; picture-in-picture';

function createEmbedIframe(_ref2) {
  var src = _ref2.src,
      props = _objectWithoutProperties(_ref2, _excluded);

  return createElement('iframe', _objectSpread({
    src: src,
    width: '100%',
    height: '100%',
    allow: allow,
    frameborder: 0
  }, props));
}

function serialize(props) {
  return Object.keys(props).map(function (key) {
    if (props[key] == null) return '';
    return "".concat(key, "=").concat(encodeURIComponent(props[key]));
  }).join('&');
}

function boolToBinary(props) {
  var p = _objectSpread({}, props);

  for (var key in p) {
    if (p[key] === false) p[key] = 0;else if (p[key] === true) p[key] = 1;
  }

  return p;
}
/**
 * Creates a fake `TimeRanges` object.
 *
 * A TimeRanges object. This object is normalized, which means that ranges are
 * ordered, don't overlap, aren't empty, and don't touch (adjacent ranges are
 * folded into one bigger range).
 *
 * @param  {(Number|Array)} Start of a single range or an array of ranges
 * @param  {Number} End of a single range
 * @return {Array}
 */


function createTimeRanges(start, end) {
  if (Array.isArray(start)) {
    return createTimeRangesObj(start);
  } else if (start == null || end == null || start === 0 && end === 0) {
    return createTimeRangesObj([[0, 0]]);
  }

  return createTimeRangesObj([[start, end]]);
}

function createTimeRangesObj(ranges) {
  Object.defineProperties(ranges, {
    start: {
      value: function value(i) {
        return ranges[i][0];
      }
    },
    end: {
      value: function value(i) {
        return ranges[i][1];
      }
    }
  });
  return ranges;
}

if (globalThis.customElements && !globalThis.customElements.get('youtube-video')) {
  globalThis.customElements.define('youtube-video', YoutubeVideoElement);
}

export default YoutubeVideoElement;